import { render } from "./userinfoView.vue?vue&type=template&id=0bb5211d&scoped=true&ts=true"
import script from "./userinfoView.vue?vue&type=script&lang=ts"
export * from "./userinfoView.vue?vue&type=script&lang=ts"

import "./userinfoView.vue?vue&type=style&index=0&id=0bb5211d&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb5211d"]])

export default __exports__